import type { CustomField } from "@/schema"

export function getSelectOptionColor(customField: CustomField, option: string): string | undefined {
  return customField.options?.select_option_colors?.[option]
}

export function SelectOptionDot({ customField, option }: { customField: CustomField; option: string }) {
  const color = getSelectOptionColor(customField, option)
  if (!color) return null

  return <span className="size-2 shrink-0 rounded-full" style={{ backgroundColor: color }} />
}
